export const queryKeys = {
  listOffers: "listOffers",
  listProducts: "listProducts",
  listFavorites: "listFavorites",
  listPopularProducts: "listPopularProducts",
  listOrders: "listOrders",
  listCart: "listCart",
};
